import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getDashboardByWorkstream } from "../modules/CustomDashboardModule/services/DashboardConfigurationService";
import { useReduxQuery } from "./useReduxQuery";

const streamList = ["home"];

/**
 * Unifies logic for tabs within a dashboard
 * 1. Listing Tabs
 * 2. Fetching Tabs
 * And whatnot
 * @param {Object} props - The module's config so this hook knows what to update
 * @param {string} props.stream - the stream to fetch the tabs on
 * @param {function} props.selector - a redux selector so we can return the tabs from this hook instead of having multiple selectors all over the place
 * @param {function} props.onResponse - a redux action to pass in the fetched tabs
 * @param {function} props.onLoading - a redux action to update that the tabs are being fetched
 * @param {function} props.onError - a redux action to set a tabs fetch error
 * @returns {Object}
 */
export const useTabsByWorkStreamQuery = ({
  stream,
  selectors,
  onResponse,
  onLoading,
  onError,
}) => {
  const query = useReduxQuery({
    queryFn: getDashboardByWorkstream,
    args: [stream],
    enabled: true,
    selector: selectors.isLoading,
    onLoading,
    onResponse,
    onError,
  });

  useEffect(() => {
    query();
  }, [stream]);

  return useSelector(selectors.tabs);
};
